import { render } from "./PhotoList.vue?vue&type=template&id=f21d65ce"
import script from "./PhotoList.vue?vue&type=script&lang=js"
export * from "./PhotoList.vue?vue&type=script&lang=js"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__